import { useEffect, useRef } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const domains = [
  { icon: 'ri-palette-line', label: 'Design graphique' },
  { icon: 'ri-eye-line', label: 'Identité visuelle' },
  { icon: 'ri-file-list-3-line', label: 'Création de supports' },
];

export default function AboutPage() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.title = 'À propos — HASPICA Studio de Design Bordeaux';
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    const els = ref.current?.querySelectorAll('.section-appear') ?? [];
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref}>
      <Navbar />

      {/* Page header */}
      <section className="pt-40 pb-20 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <p className="section-appear text-xs font-semibold text-neutral-400 uppercase tracking-widest mb-5">
            À propos
          </p>
          <h1 className="section-appear font-heading text-5xl md:text-6xl lg:text-7xl text-neutral-900 font-light leading-tight">
            Le studio<br />
            <em className="italic">HASPICA</em>
          </h1>
        </div>
      </section>

      {/* Main content */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          <div className="section-appear">
            <img
              src="https://public.readdy.ai/ai/img_res/b588a35606fd653814ae86365b81b964.jpg"
              alt="Patrik Haspica, designer"
              className="w-full h-[500px] lg:h-[600px] object-cover object-top rounded-sm"
            />
          </div>

          <div className="section-appear space-y-10">
            <div>
              <p className="text-sm text-neutral-500 leading-relaxed mb-6">
                HASPICA est une activité indépendante de design graphique et de conception créative, basée à Bordeaux. Le studio est dirigé par <strong className="text-neutral-900 font-medium">Patrik Haspica</strong>, designer proposant des solutions visuelles adaptées pour différents types de projets.
              </p>
              <p className="text-sm text-neutral-500 leading-relaxed">
                L'objectif est de proposer des solutions de design graphique modernes, fonctionnelles et adaptées à chaque client, qu'il s'agisse d'entreprises ou de particuliers. Chaque création d'identité visuelle est pensée pour être cohérente, durable et mémorable.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-2xl text-neutral-900 font-medium mb-6">Domaines d'intervention</h2>
              <div className="space-y-4">
                {domains.map((d) => (
                  <div key={d.label} className="flex items-center gap-4 border-t border-neutral-100 pt-4">
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className={`${d.icon} text-lg text-neutral-400`} />
                    </div>
                    <span className="text-sm text-neutral-700 font-medium">{d.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="border-t border-neutral-200 pt-8">
              <p className="text-xs text-neutral-400 uppercase tracking-widest font-semibold mb-3">Studio</p>
              <p className="text-sm text-neutral-500">
                12 Rue Judaïque, 33000 Bordeaux<br />
                SIRET&nbsp;: 102 262 441 00011<br />
                NAF&nbsp;: 74.10Z — Activités spécialisées de design
              </p>
            </div>

            <Link
              to="/contact"
              className="inline-block px-8 py-3.5 bg-neutral-900 text-white text-sm font-medium rounded-sm hover:bg-neutral-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              Discuter d'un projet
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
